<div class="flex flex-col gap-4" animate.enter="anim-fade-from-bottom">
  <!-- Row 1: Short vowels, Long vowels, Space -->
  <rid-keyboard-row>
    <rid-key-group>
      @for (key of keyboardKeyGroups['KLINKERS']; track key) {
        <rid-keyboard-key
          [key]="key"
          [hidden]="isHidden(key.value)"
          [hasHighlight]="hasHighlight(key.value)"
          [disabled]="!isEnabled(key.value)"
          (pressed)="type(key.value)"
        />
      }
    </rid-key-group>
    <rid-key-group>
      <rid-keyboard-key
        [key]="convertValueToKey('▭')"
        [hidden]="isHidden('▭')"
        [hasHighlight]="hasHighlight('▭')"
        [disabled]="!isEnabled('▭')"
        (pressed)="type('▭')"
      />
      @for (pair of doubleVowelKeys; track $index) {
        @let longKey = pair[0];
        @let shortKey = pair[1];
        <rid-long-vowel-key-wrapper
          [class.hidden]="isHidden(longKey.value) && isHidden(shortKey.value)"
          [disabled]="!isEnabled(longKey.value) && !isEnabled(shortKey.value)"
        >
          <rid-keyboard-key
            [key]="longKey"
            [hidden]="isHidden(longKey.value)"
            [hasHighlight]="hasHighlight(longKey.value)"
            [disabled]="!isEnabled(longKey.value)"
            (pressed)="type(longKey.value)"
          />
          <rid-keyboard-key
            [key]="shortKey"
            [hidden]="isHidden(shortKey.value)"
            [hasHighlight]="hasHighlight(shortKey.value)"
            [disabled]="!isEnabled(shortKey.value)"
            (pressed)="type(shortKey.value)"
          />
        </rid-long-vowel-key-wrapper>
      }
    </rid-key-group>
    <rid-key-group>
      @for (key of keyboardKeyGroups['SPACE']; track key) {
        <rid-keyboard-key
          [key]="key"
          [hidden]="isHidden(key.value)"
          [hasHighlight]="hasHighlight(key.value)"
          [disabled]="!isEnabled(key.value)"
          (pressed)="type(key.value)"
        />
      }
    </rid-key-group>
  </rid-keyboard-row>

  <!-- Row 2: Two-letter phonemes -->
  <rid-keyboard-row>
    <rid-key-group>
      @for (key of keyboardKeyGroups['DUBBELE_KLINKERS']; track key) {
        <rid-keyboard-key
          [key]="key"
          [hidden]="isHidden(key.value)"
          [hasHighlight]="hasHighlight(key.value)"
          [disabled]="!isEnabled(key.value)"
          (pressed)="type(key.value)"
        />
      }
    </rid-key-group>
  </rid-keyboard-row>

  <!-- Row 3: Three-letter and Four-letter phonemes -->
  <rid-keyboard-row>
    <rid-key-group>
      @for (key of keyboardKeyGroups['DRIEDUBBELE_KLINKERS']; track key) {
        <rid-keyboard-key
          [key]="key"
          [hidden]="isHidden(key.value)"
          [hasHighlight]="hasHighlight(key.value)"
          [disabled]="!isEnabled(key.value)"
          (pressed)="type(key.value)"
        />
      }
    </rid-key-group>
    <rid-key-group>
      @for (key of keyboardKeyGroups['VIERDUBBELE_KLINKERS']; track key) {
        <rid-keyboard-key
          [key]="key"
          [hidden]="isHidden(key.value)"
          [hasHighlight]="hasHighlight(key.value)"
          [disabled]="!isEnabled(key.value)"
          (pressed)="type(key.value)"
        />
      }
    </rid-key-group>
  </rid-keyboard-row>

  <!-- Row 4: Consonants -->
  <rid-keyboard-row>
    <rid-key-group>
      @for (key of keyboardKeyGroups['MEDEKLINKERS']; track key) {
        <rid-keyboard-key
          [key]="key"
          [hidden]="isHidden(key.value)"
          [hasHighlight]="hasHighlight(key.value)"
          [disabled]="!isEnabled(key.value)"
          (pressed)="type(key.value)"
        />
      }
    </rid-key-group>
  </rid-keyboard-row>

  <!-- Row 5: Specials -->
  <rid-keyboard-row>
    <rid-key-group>
      @for (key of keyboardKeyGroups['EXOTEN']; track key) {
        <rid-keyboard-key
          [key]="key"
          [hidden]="isHidden(key.value)"
          [hasHighlight]="hasHighlight(key.value)"
          [disabled]="!isEnabled(key.value)"
          (pressed)="type(key.value)"
        />
      }
    </rid-key-group>
    <rid-key-group>
      @for (key of keyboardKeyGroups['SJWAS']; track key) {
        <rid-keyboard-key
          [key]="key"
          [hidden]="isHidden(key.value)"
          [hasHighlight]="hasHighlight(key.value)"
          [disabled]="!isEnabled(key.value)"
          (pressed)="type(key.value)"
        />
      }
    </rid-key-group>
    <rid-key-group>
      @for (key of keyboardKeyGroups['KLANKVOET']; track key) {
        <rid-keyboard-key
          [key]="key"
          [hidden]="isHidden(key.value)"
          [hasHighlight]="hasHighlight(key.value)"
          [disabled]="!isEnabled(key.value)"
          (pressed)="type(key.value)"
        />
      }
    </rid-key-group>
    <rid-key-group>
      @for (key of keyboardKeyGroups['RULE']; track key) {
        <rid-keyboard-key
          [key]="key"
          [hidden]="isHidden(key.value)"
          [hasHighlight]="hasHighlight(key.value)"
          [disabled]="!isEnabled(key.value)"
          (pressed)="type(key.value)"
        />
      }
    </rid-key-group>
  </rid-keyboard-row>
</div>
